import { Fragment, useEffect, useState } from "react";
import "./user_analytics_content_component.scss";
import { isEmpty } from "../../../../custom_utilities/custom_useful_functions";
import axios from "axios";
import {
  url_63,
  url_9,
  url_41,
  url_42,
  url_287,
} from "../../../../custom_utilities/api_services";
import moment from "moment";
import SubjectWiseDoughnut from "../../../../components/canvas_charts/canvas_doughnut_chart/SubjectWiseDoughnut";
import OverallDifficultyWiseProgress from "../../../../components/canvas_charts/canvas_doughnut_chart/OverallDifficultyWiseProgress";
import CorrectIncorrectDoughnutChart from "../../../../components/canvas_charts/canvas_doughnut_chart/CorrectIncorrectDoughnutChart";
import AttemptUnattemptDoughnutChart from "../../../../components/canvas_charts/canvas_doughnut_chart/AttemptUnattemptDoughnutChart";
import OverallStrongAndImproveTopics from "../overall_strong_and_improve_topics/OverallStrongAndImproveTopics";
import { connect } from "react-redux";
import uiActions from "../../../../redux/ui/action";
import userTestsExercisesAction from "../../../../redux/user_tests_exercises/action";
import { setPaperId } from "../../../../parent/redux/testDataSlice/TestDataSlice";
import {
  setUserId,
  setLoginFromParentFlag,
  setParentTarget,
} from "../../../../parent/redux/authSlice/AuthSlice";
import images from "../../../../utilities/images/images";

const FOUNDATION_TARGETS_HIDE_OVERALL = [10, 11];

const UserAnalyticsContentComponent = (props) => {
  let {
    history,
    userPreference,
    startLoading,
    finishLoading,
    userId,
    setUserId,
    setPaperId,
    setLoginFromParentFlag,
    setParentTarget,
    target,
    targetId,
  } = props;

  const resolvedTargetId = Number(
    targetId ?? userPreference?.targetDetails?.[0]?.target_id
  );
  const hideOverallTestTab =
    FOUNDATION_TARGETS_HIDE_OVERALL.includes(resolvedTargetId);

  const [state, setState] = useState({
    tabType: 1, // Default tabType
    overAllTestsData: {},
    individualTestSubjectDataDetails: {
      subjectId: "",
      subjectName: "",
      subjectIcon: "",
    },
    individualTestSubjectList: {},
    individualTestList: {},
    individualTestInitialSubjectCheck: true,
    individualTestListPageNumber: 1,
    learnAnalysisSubjectDataDetails: {
      subjectId: "",
      subjectName: "",
      subjectIcon: "",
    },
    learnAnalysisSubjectList: {},
    learnAnalysisData: {},
    learnAnalysisInitialSubjectCheck: true,
  });

  // Schoolympiad / foundation targets (10, 11): only Individual Test. Otherwise honor dashboard link tab hint.
  useEffect(() => {
    if (hideOverallTestTab) {
      setState((prevState) => ({
        ...prevState,
        tabType: 2,
        individualTestInitialSubjectCheck: true,
      }));
      sessionStorage.removeItem("activeTab");
      return;
    }

    const activeTab = sessionStorage.getItem("activeTab");
    if (activeTab === "individual_test") {
      setState((prevState) => ({
        ...prevState,
        tabType: 2,
        individualTestInitialSubjectCheck: true,
      }));
      sessionStorage.removeItem("activeTab");
    }
  }, [hideOverallTestTab]);

  useEffect(() => {
    if (state.tabType === 1) {
      if (!hideOverallTestTab) {
        getOverAllTestsData();
      }
    } else if (state.tabType === 2) {
      getIndividualTestSubjectList();
    } else if (state.tabType === 3) {
      getLearnAnalysisSubjectList();
    }
  }, [state.tabType, hideOverallTestTab]);

  useEffect(() => {
    if (
      state.tabType === 2 &&
      !isEmpty(state.individualTestSubjectList) &&
      state.individualTestSubjectList.subject.length &&
      state.individualTestInitialSubjectCheck
    ) {
      getIndividualTestInitialData();
    }
  }, [state.tabType, state.individualTestSubjectList]);

  useEffect(() => {
    if (
      state.tabType === 3 &&
      !isEmpty(state.learnAnalysisSubjectList) &&
      state.learnAnalysisSubjectList.subject.length &&
      state.learnAnalysisInitialSubjectCheck
    ) {
      getLearnAnalysisInitialData();
    }
  }, [state.tabType, state.learnAnalysisSubjectList]);

  const getIndividualTestInitialData = () => {
    let { subject } = state.individualTestSubjectList;

    setState((prevState) => ({
      ...prevState,
      individualTestSubjectDataDetails: {
        ...prevState.individualTestSubjectDataDetails,
        subjectId: subject?.[0]?.sub_id,
        subjectName: subject?.[0]?.sub_name,
        subjectIcon: subject?.[0]?.icon,
      },
      individualTestInitialSubjectCheck: false,
    }));

    getIndividualTestList(subject?.[0]?.sub_id);
  };

  const getLearnAnalysisInitialData = () => {
    let { subject } = state.learnAnalysisSubjectList;

    setState((prevState) => ({
      ...prevState,
      learnAnalysisSubjectDataDetails: {
        ...prevState.learnAnalysisSubjectDataDetails,
        subjectId: subject?.[0]?.sub_id,
        subjectName: subject?.[0]?.sub_name,
        subjectIcon: subject?.[0]?.icon,
      },
      learnAnalysisInitialSubjectCheck: false,
    }));

    getLearnAnalysisData(subject?.[0]?.sub_id);
  };

  const getOverAllTestsData = async () => {
    startLoading();
    try {
      const response = await axios.get(url_63);
      if (response.data.status === 200) {
        finishLoading();
        setState((prevState) => ({
          ...prevState,
          overAllTestsData: response?.data.data,
        }));
      } else {
        finishLoading();
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  };

  const getIndividualTestSubjectList = async () => {
    let requestPayload = {
      course_id: userPreference?.courseDetails?.[0]?.course_id,
      class_id: userPreference?.classDetails?.class_id,
    };
    startLoading();
    try {
      const response = await axios.post(url_9, requestPayload);
      if (response.data.status === 200) {
        finishLoading();
        setState((prevState) => ({
          ...prevState,
          individualTestSubjectList: response.data.data,
        }));
      } else {
        finishLoading();
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  };

  const handleTabChange = (tabType) => {
    switch (tabType) {
      case "overall_tests":
        setState((prevState) => ({
          ...prevState,
          tabType: 1,
          individualTestInitialSubjectCheck: true,
        }));
        break;
      case "individual_test":
        setState((prevState) => ({
          ...prevState,
          tabType: 2,
          individualTestInitialSubjectCheck: true,
        }));
        break;
      case "learn_analysis":
        setState((prevState) => ({
          ...prevState,
          tabType: 3,
          individualTestInitialSubjectCheck: true,
        }));
        break;
      default:
        break;
    }
  };

  const getIndividualTestList = async (subject_id) => {
    startLoading();
    try {
      const response = await axios.get(url_41);
      if (response.data.status === 200) {
        finishLoading();
        setState((prevState) => ({
          ...prevState,
          individualTestList: response.data.data,
        }));
      } else {
        finishLoading();
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  };

  const openFoundationTestReportPdf = async (paper_id) => {
    startLoading();
    try {
      const response = await axios.get(url_287, {
        params: { paper_id, user_id: userId },
      });
      const payload = response.data;
      finishLoading();

      const pdfUrl = payload?.data?.pdf_url;
      if (payload?.status === 200 && pdfUrl) {
        window.open(pdfUrl, "_blank", "noopener,noreferrer");
        return;
      }

      const msg = payload?.message;
      if (typeof msg === "string" && msg && msg !== "Success") {
        alert(msg);
      } else {
        alert("Could not load report.");
      }
    } catch (error) {
      finishLoading();
      console.log(error);
      alert("Could not open report. Please try again.");
    }
  };

  const handleRedirectToParent = async (testData) => {
    if (!testData.view_sol_time) {
      alert(`Solutions will be shown after ${testData.view_solution}`);
      return;
    }

    if (hideOverallTestTab) {
      await openFoundationTestReportPdf(testData.paper_id);
      return;
    }

    await setParentTarget(target);
    setPaperId(testData.paper_id);
    setUserId(userId);
    setLoginFromParentFlag(false);

    history.push({
      pathname: "/student-tests",
      state: {
        step: 2,
      },
    });
  };

  const getLearnAnalysisSubjectList = async () => {
    let requestPayload = {
      course_id: userPreference.courseDetails[0].course_id,
      class_id: userPreference.classDetails.class_id,
    };
    startLoading();
    try {
      const response = await axios.post(url_9, requestPayload);
      if (response.data.status === 200) {
        finishLoading();
        setState((prevState) => ({
          ...prevState,
          learnAnalysisSubjectList: response.data.data,
        }));
      } else {
        finishLoading();
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  };

  const getLearnAnalysisData = async (subject_id) => {
    startLoading();
    try {
      const response = await axios.get(`${url_42}?subject_id=${subject_id}`);
      if (response.data.status === 200) {
        finishLoading();
        setState((prevState) => ({
          ...prevState,
          learnAnalysisData: response.data.data,
        }));
      } else {
        finishLoading();
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  };

  return (
    <Fragment>
      <div className="userAnalyticsContentComponent_wrapper">
        <div className="container-fluid container-lg">
          <div className="userAnalyticsContentComponent_inner_wrapper">
            <div className="section_wrapper">
              <div className="section_inner_wrapper">
                <div className="user_analytics_page_header">
                  <button
                    type="button"
                    className="user_analytics_back_btn"
                    aria-label="Back to dashboard"
                    onClick={() => history.push("/user_dashboard")}
                  >
                    <img src={images.new_backarrow} alt="" />
                  </button>
                  <h2>Test Analytics</h2>
                  <span className="user_analytics_back_spacer" aria-hidden />
                </div>
                <div className="options_wrapper">
                  <ul
                    className="nav nav-pills custom_nav_pills"
                    id="pills-tab"
                    role="tablist"
                  >
                    {!hideOverallTestTab ? (
                      <li
                        className="nav-item custom_nav_item"
                        role="presentation"
                      >
                        <button
                          className={`nav-link ${
                            state.tabType === 1 ? "active" : ""
                          } custom_nav_link`}
                          id="pills-overall-test-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-overall-test"
                          type="button"
                          role="tab"
                          aria-controls="pills-overall-test"
                          aria-selected={state.tabType === 1}
                          onClick={() => handleTabChange("overall_tests")}
                        >
                          Overall Test
                        </button>
                      </li>
                    ) : null}
                    <li
                      className="nav-item custom_nav_item"
                      role="presentation"
                    >
                      <button
                        className={`nav-link ${
                          state.tabType === 2 ? "active" : ""
                        } custom_nav_link`}
                        id="pills-individual-test-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-individual-test"
                        type="button"
                        role="tab"
                        aria-controls="pills-individual-test"
                        aria-selected={state.tabType === 2}
                        onClick={() => handleTabChange("individual_test")}
                      >
                        Individual Test
                      </button>
                    </li>
                  </ul>
                </div>
                <div className="tab_wrapper">
                  <div
                    className="tab-content custom_tab_content"
                    id="pills-tabContent"
                  >
                    {/* Overall Test Tab */}
                    {!hideOverallTestTab ? (
                      <div
                        className={`tab-pane fade ${
                          state.tabType === 1 ? "show active" : ""
                        } custom_tab_pane`}
                        id="pills-overall-test"
                        role="tabpanel"
                        aria-labelledby="pills-overall-test-tab"
                      >
                        <div className="overall_test_tab_wrapper">
                          <div className="outer_content_wrapper">
                            <div className="Chartcontent_wrapper">
                              <div className="sec_1_wrapper">
                                {!isEmpty(state.overAllTestsData) ? (
                                  state.overAllTestsData.OverallSubjectReport
                                    .length ? (
                                    <SubjectWiseDoughnut
                                      dataPoints={
                                        state.overAllTestsData
                                          .OverallSubjectReport
                                      }
                                    />
                                  ) : null
                                ) : null}

                                {!isEmpty(state.overAllTestsData) ? (
                                  state.overAllTestsData.OverallDifficultyReport
                                    .length ? (
                                    <OverallDifficultyWiseProgress
                                      dataPoints={
                                        state.overAllTestsData
                                          .OverallDifficultyReport
                                      }
                                    />
                                  ) : null
                                ) : null}
                              </div>

                              <div className="sec_1_wrapper">
                                {!isEmpty(state.overAllTestsData) ? (
                                  state.overAllTestsData.TestChartQuestionsData
                                    ?.length ? (
                                    <CorrectIncorrectDoughnutChart
                                      dataPoints={
                                        state.overAllTestsData
                                          .TestChartQuestionsData
                                      }
                                    />
                                  ) : null
                                ) : null}

                                {!isEmpty(state.overAllTestsData) ? (
                                  state.overAllTestsData.TestChartData
                                    ?.length ? (
                                    <AttemptUnattemptDoughnutChart
                                      title={"All Tests"}
                                      dataDetails={
                                        state.overAllTestsData.TestChartData
                                      }
                                    />
                                  ) : null
                                ) : null}
                              </div>

                              <div className="sec_1_wrapper">
                                {!isEmpty(state.overAllTestsData) ? (
                                  <OverallStrongAndImproveTopics
                                    subjects={
                                      state.overAllTestsData.OverallSubject
                                    }
                                  />
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    {/* Individual Test Tab */}
                    <div
                      className={`tab-pane fade ${
                        state.tabType === 2 ? "show active" : ""
                      } custom_tab_pane`}
                      id="pills-individual-test"
                      role="tabpanel"
                      aria-labelledby="pills-individual-test-tab"
                    >
                      <div className="individual_test_tab_wrapper">
                        <div className="outer_content_wrapper">
                          <div className="right_side_content_wrapper">
                            <div className="tests_collection_wrapper">
                              {!isEmpty(state.individualTestList)
                                ? state.individualTestList.TestList?.data
                                    ?.length
                                  ? state.individualTestList.TestList.data.map(
                                      (element, index) => (
                                        <div
                                          key={index}
                                          className="single_test_wrapper"
                                        >
                                          <div className="sub_section_wrapper_1">
                                            <label>{`Start at ${moment(
                                              element.start_date
                                            ).format("MMMM Do YYYY")}`}</label>
                                            <div className="paper_idd">
                                              <span className="paper_id_text">
                                                Paper ID:{" "}
                                              </span>
                                              {element.paper_id}
                                            </div>
                                          </div>
                                          <div className="sub_section_wrapper_2">
                                            <div className="text_content_wrapper">
                                              <p className="text_content">
                                                {element.paper_name}
                                              </p>
                                            </div>
                                          </div>
                                          <div>
                                            <p>
                                              Attempted on-{" "}
                                              {element.attempted_on}
                                            </p>
                                          </div>
                                          <div className="sub_section_wrapper_3">
                                            <div className="sub_content_wrapper">
                                              <div className="left_content_wrapper">
                                                <label>{`${element.total_questions} ques | ${element.duration_mins}min | ${element.total_marks} marks`}</label>
                                              </div>
                                              <div className="right_content_wrapper">
                                                <label
                                                  className="lbl_1"
                                                  onClick={() =>
                                                    handleRedirectToParent(
                                                      element
                                                    )
                                                  }
                                                >
                                                  {hideOverallTestTab
                                                    ? "View report"
                                                    : "View solution"}
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )
                                    )
                                  : null
                                : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    token: state.auth.authToken,
    tokenType: state.auth.tokenType,
    userId: state.auth.user.user_id,
    target: state?.auth?.user?.UsertargetDetail[0]?.target,
    targetId: state?.auth?.user?.UsertargetDetail?.[0]?.target_id,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
    setUserTestsResultData: (payload) => {
      dispatch(userTestsExercisesAction.setUserTestsResultData(payload));
    },
    setPaperId: (payload) => {
      dispatch(setPaperId(payload));
    },
    setUserId: (payload) => {
      dispatch(setUserId(payload));
    },
    setLoginFromParentFlag: (payload) => {
      dispatch(setLoginFromParentFlag(payload));
    },
    setParentTarget: (payload) => {
      dispatch(setParentTarget(payload));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserAnalyticsContentComponent);
